export default {
  RESET_FILTERS: 'RESET_FILTERS',
  RESET_TICKET_FILTERS: 'RESET_TICKET_FILTERS',
  SET_CHANNEL: 'SET_CHANNEL',
  SET_CONFIG: 'SET_CONFIG',
  SET_EXPORT_TYPE: 'SET_EXPORT_TYPE',
  SET_FILTERS: 'SET_FILTERS',
  SET_INFO_MESSAGE: 'SET_INFO_MESSAGE',
  SET_JACKPOTS: 'SET_JACKPOTS',
  SET_PAGINATION: 'SET_PAGINATION',
  SET_PLATFORM: 'SET_PLATFORM',
  SET_ROUNDS: 'SET_ROUNDS',
  SET_TICKETS: 'SET_TICKETS',
  SET_TICKETS_TOTALS: 'SET_TICKETS_TOTALS',
  SET_TICKET_BETS: 'SET_TICKET_BETS',
  SET_TICKET_FILTERS: 'SET_TICKET_FILTERS',
  SET_TRANSLATIONS: 'SET_TRANSLATIONS',
  SET_USER: 'SET_USER',
  SET_USER_TOKEN: 'SET_USER_TOKEN',
  UPDATE_CONFIG: 'UPDATE_CONFIG',
};
